import { Routes } from '@angular/router';
import { EntitiesComponent } from '@components/administration/entities/entities.component';
import { OfficeComponent } from '@components/administration/offices/office.component';
import { GroupComponent } from '@components/administration/groups/groups.component';
import { AdminEvaluationComponent } from '@components/administration/evaluation/admin-evaluation.component';
import { AdminGoalsComponent } from '@components/administration/evaluation/admin-goals.component';
import { ModulesComponent } from '@components/administration/modules/modules.component';
import { QuestionTypesComponent } from '@components/administration/question-types/question-types.component';
import { UsersManagementComponent } from '@components/user/users-management/users-management.component';
import { UserRolesComponent } from '@components/user/roles/roles.component';
import { MenusComponent } from '@components/user/menus/menus.component';
import { authGuard } from '@guards/auth.guard';
import { entitiesResolver } from './resolvers/entities.resolver';
import { officeResolver } from './resolvers/office.resolver';
import { groupResolver } from './resolvers/group.resolver';
import { usersManagementResolver } from './resolvers/users-management.resolver';
import { rolesResolver } from './resolvers/roles.resolver';
import { menusResolver } from './resolvers/menus.resolver';
import { evaluationTemplateResolver } from './resolvers/evaluation-template.resolver';
import { goalsResolver } from './resolvers/goals.resolver';
import { moduleRouteResolver } from './resolvers/module-route.resolver';
import { PeriodsComponent } from '@components/administration/periods/periods.component';
import { PeriodHistoryComponent } from '@components/administration/period-history/period-history.component';
import { EvaluationFillComponent } from '@components/evaluation/fill/evaluation-fill.component';

export const routes: Routes = [
    {
        path: 'admin',
        canActivate: [authGuard],
        children: [
            {
                path: 'entidades',
                component: EntitiesComponent,
                resolve: { entitiesData: entitiesResolver }
            },
            {
                path: 'grupos',
                component: GroupComponent,
                resolve: { groupData: groupResolver }
            },
            {
                path: 'campos',
                component: OfficeComponent,
                resolve: { officeData: officeResolver }
            },
            {
                path: 'evaluacion/:moduleRoute',
                component: AdminEvaluationComponent,
                resolve: { templateData: evaluationTemplateResolver }
            },
            {
                path: ':moduleRoute/metas',
                component: AdminGoalsComponent,
                resolve: { goalsData: goalsResolver }
            },
            {
                path: 'modulos',
                component: ModulesComponent
            },
            {
                path: 'preguntas',
                component: QuestionTypesComponent
            },
            {
                path: 'usuarios',
                component: UsersManagementComponent,
                resolve: { usersManagementData: usersManagementResolver }
            },
            {
                path: 'roles',
                component: UserRolesComponent,
                resolve: { rolesData: rolesResolver }
            },
            {
                path: 'menus',
                component: MenusComponent,
                resolve: { menusData: menusResolver }
            }
        ]
    },
    {
        path: ':moduleRoute/periodos',
        canActivate: [authGuard],
        component: PeriodsComponent,
        resolve: { periodsData: moduleRouteResolver() }
    },
    {
        path: ':moduleRoute/historial',
        canActivate: [authGuard],
        component: PeriodHistoryComponent,
        resolve: { historyData: moduleRouteResolver() }
    },
    {
        path: ':moduleRoute/evaluacion',
        canActivate: [authGuard],
        component: EvaluationFillComponent,
        resolve: { fillData: moduleRouteResolver() }
    }
];
